/**
* 基础菜单 营销管理
*/
<template>
  <div class="contianer">
    <!-- 面包屑导航 -->
    <!-- <div class="breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>营销管理</el-breadcrumb-item>
        <el-breadcrumb-item>优惠券规则管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div> -->
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="">
        <el-input size="small" v-model="formInline.rule_name" placeholder="规则名称" clearable></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-input size="small" v-model="formInline.full_money" placeholder="满额使用金额" clearable></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-select v-model="formInline.voucher_rule_type" placeholder="请选择规则类型" clearable>
          <el-option v-for="type in VoucherRuleType" :key="type.code" :label="type.name"
                     :value="type.code"></el-option>
        </el-select>
      </el-form-item>
<!--      <el-form-item label="">-->
<!--        <el-select v-model="formInline.order_full_use" placeholder="是否单笔订单满额使用" clearable>-->
<!--          <el-option label="是" value="1"></el-option>-->
<!--          <el-option label="否" value="0"></el-option>-->
<!--        </el-select>-->
<!--      </el-form-item>-->
      <el-form-item>
        <el-button size="small" type="primary" @click="search">查询</el-button>
        <el-button size="small" type="success" @click="addsortdialog" class="add-button">新增</el-button>
        <el-button size="small" type="info" @click="editupdate" class="edit-button">修改</el-button>
        <el-button size="small" type="danger" @click="delProduct">删除</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <div style="height: 530px;overflow-y: auto">
      <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border
                @cell-dblclick="cellDbClick" @selection-change="handleSelectionChange"
                :header-cell-style="{background:'#F5F7FA',color:'#666666'}"
                element-loading-text="拼命加载中" style="width: 80%;">
        <el-table-column align="center" type="selection" width="60">
        </el-table-column>
        <el-table-column
          label="序号"
          width="60">
          <template slot-scope="scope">
            {{pageparm.pageSize * (pageparm.currentPage - 1) + (scope.$index + 1)}}
          </template>
        </el-table-column>
        <el-table-column prop="rule_name" label="规则名称" width="300">
        </el-table-column>
        <el-table-column prop="voucher_rule_type" label="规则类型" min-width="150">
          <template slot-scope="scope">
            <div>{{Formatter(scope.row.voucher_rule_type,'VoucherRuleType')}}</div>
          </template>
        </el-table-column>
<!--        <el-table-column prop="order_full_use" label="是否单笔订单满额使用" width="160">-->
<!--          <template slot-scope="scope">-->
<!--            <div v-if="scope.row.order_full_use">是</div>-->
<!--            <div v-else-if="scope.row.order_full_use==0">否</div>-->
<!--            <div></div>-->
<!--          </template>-->
<!--        </el-table-column>-->
        <el-table-column prop="full_money" label="满额使用金额" width="200">
        </el-table-column>
<!--        <el-table-column prop="contain_delivery" label="是否包含邮费" width="160">-->
<!--          <template slot-scope="scope">-->
<!--            <div v-if="scope.row.contain_delivery">是</div>-->
<!--            <div v-else-if="scope.row.contain_delivery==0">否</div>-->
<!--            <div></div>-->
<!--          </template>-->
<!--        </el-table-column>-->
        <el-table-column prop="creator_name" label="创建人" width="180">
        </el-table-column>
        <el-table-column align="left" label="操作" width="174">
          <template slot-scope="scope">
            <el-button type="text" size="mini" style="margin-right: 8px" v-if="scope.row.voucher_rule_type==1042"
                       @click="lookBrand(scope.row.id)">
              查看品牌
            </el-button>
            <el-button type="text" size="mini" style="margin-right: 8px;color: #53B03C;"
                       v-if="scope.row.voucher_rule_type==1041" @click="lookSort(scope.row.id)">
              查看品类
            </el-button>
            <el-button type="text" size="mini" @click="lookCoupon(scope.row.id)">
              查看优惠券
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <el-dialog :close-on-click-modal="false" :close-on-press-escape="false"
               :title="dialogTitle"
               :visible.sync="voucherDialogVisible"
               width="30%"
               :before-close="handleClose"
               center>
      <el-form :model="voucherForm" :rules="rules" ref="voucherForm" label-width="165px" class="voucherForm">
        <el-form-item label="规则名称" prop="rule_name" class="relative">
          <el-input v-model="voucherForm.rule_name" auto-complete="off" clearable placeholder="请输入规则名称">
          </el-input>
        </el-form-item>
<!--        <el-form-item label="包含邮费" prop="contain_delivery">-->
<!--          <el-select v-model="voucherForm.contain_delivery" placeholder="是否包含邮费" clearable>-->
<!--            <el-option v-for="item in containList" :key="item.value" :label="item.name"-->
<!--                       :value="item.value"></el-option>-->
<!--          </el-select>-->
<!--        </el-form-item>-->
<!--        <el-form-item label="是否单笔订单满额使用" prop="order_full_use">-->
<!--          <el-select v-model="voucherForm.order_full_use" placeholder="是否单笔订单满额使用" clearable>-->
<!--            <el-option v-for="item in orderList" :key="item.value" :label="item.name"-->
<!--                       :value="item.value"></el-option>-->
<!--          </el-select>-->
<!--        </el-form-item>-->
        <el-form-item label="规则类型" prop="voucher_rule_type">
          <el-select v-model="voucherForm.voucher_rule_type" placeholder="请选择规则类型" clearable>
            <el-option v-for="type in VoucherRuleType" :key="type.code" :label="type.name=='全场通用'?'店铺通用':type.name"
                       :value="type.code"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="满额使用金额" prop="full_money" class="relative" max-length="8">
          <el-input v-model="voucherForm.full_money" auto-complete="off" clearable placeholder="请输入满额使用金额"
                    clearable></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
            <el-button @click="resetForm('voucherForm')">{{param2}}</el-button>
            <el-button type="primary" @click="saveSort('voucherForm')">{{param}}</el-button>
      </span>
    </el-dialog>
    <el-dialog :close-on-click-modal="false" :close-on-press-escape="false"
               title="查看分类"
               :visible.sync="sortDialogVisible"
               width="30%"
               :before-close="handleSortClose"
               center>
      <div class="center" v-if="sortButtonText=='添加'">
        该优惠券下暂未设置分类，请为优惠券设置分类。
      </div>
      <div v-else>
        <el-form :model="sortForm" :rules="sortrules" ref="sortForm" label-width="125px" class="sortForm">
          <el-form-item label="分类名称" prop="product_sort_id">
            <el-cascader :options="productOptions" :props="defaultParams" v-model="sortForm.product_sort_id"
                         @change="productSortChange(sortForm.product_sort_id)" clearable></el-cascader>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
            <el-button @click="handleSortClose">取消</el-button>
            <el-button type="primary" @click="clickSort('sortForm')">{{sortButtonText}}</el-button>
      </span>
    </el-dialog>
    <el-dialog :close-on-click-modal="false" :close-on-press-escape="false"
               title="查看品牌"
               :visible.sync="brandDialogVisible"
               width="30%"
               :before-close="handleBrandClose"
               center>
      <div class="center" v-if="brandButtonText=='添加'">
        该优惠券下暂未设置品牌，请为优惠券设置品牌。
      </div>
      <div v-else>
        <el-form :model="brandForm" :rules="brandrules" ref="brandForm" label-width="125px" class="brandForm">
          <el-form-item label="品牌名称" prop="product_brand_id">
            <el-select v-model="brandForm.product_brand_id" filterable placeholder="请选择品牌名称" clearable>
              <el-option v-for="item in ProductBrandList" :key="item.id" :label="item.name"
                         :value="item.id"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
            <el-button @click="handleBrandClose">取消</el-button>
            <el-button type="primary" @click="clickBrand('brandForm')">{{brandButtonText}}</el-button>
      </span>
    </el-dialog>
    <el-dialog :close-on-click-modal="false" :close-on-press-escape="false"
               title="查看优惠券" :before-close="prodHandleClose"
               :visible.sync="couponDialogVisible"
               width="60%"
               center>
      <div>
        <div style="height: 530px;overflow-y: auto">
          <el-form :inline="true" :model="couponFormInline" class="user-search">
            <el-form-item label="">
              <el-input size="small" v-model="couponFormInline.voucher_code" placeholder="请输入优惠券编号" clearable></el-input>
            </el-form-item>
            <el-form-item label="">
              <el-select v-model="couponFormInline.status" placeholder="是否有效" clearable>
                <el-option label="有效" value=1></el-option>
                <el-option label="无效" value=0></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button size="small" type="primary" @click="couponSearch">查询</el-button>
            </el-form-item>
          </el-form>
          <el-table size="small" :data="couponlistData" highlight-current-row v-loading="loading" border
                    @cell-dblclick="cellDbClick" @selection-change="handleSelectionChange"
                    :header-cell-style="{background:'#F5F7FA',color:'#666666'}"
                    element-loading-text="拼命加载中" style="width: 100%;">
            <el-table-column align="center" type="selection" width="60">
            </el-table-column>
            <el-table-column
              label="序号"
              width="60">
              <template slot-scope="scope">
                {{couponpageparm.pageSize * (couponpageparm.currentPage - 1) + (scope.$index + 1)}}
              </template>
            </el-table-column>
            <el-table-column prop="voucher_code" label="优惠券编号" min-width="120">
            </el-table-column>
            <el-table-column prop="money" label="优惠券金额" width="180">
            </el-table-column>
            <el-table-column prop="creater_name" label="创建人" width="180">
            </el-table-column>
            <el-table-column prop="status" label="状态" width="180">
              <template slot-scope="scope">
                <div v-if="scope.row.status">有效</div>
                <div v-else>无效</div>
                <div></div>
              </template>
            </el-table-column>
            <el-table-column prop="create_time" label="创建时间" width="180">
            </el-table-column>
          </el-table>
        </div>
        <!-- 分页组件 -->
        <Pagination v-bind:child-msg="couponpageparm" @callFather="couponCallFather"></Pagination>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import {
    CouponusagerulesList,   // 优惠券使用规则-列表
    CouponusagerulesAdd,    // 优惠券使用规则-新增
    CouponusagerulesUpdate,  // 优惠券使用规则-修改
    CouponusagerulesDelete,  // 优惠券使用规则-删除
    VoucherRulesCategoryInfo,
    productTree,
    VoucherRulesCategoryAdd,
    VoucherRulesCategoryUpdate,
    VoucherRulesbrandInfo,
    VoucherRulesbrandAdd,
    VoucherRulesbrandUpdate, productBrand, couponList
  } from '../../api/basisMG'
  import Pagination from '../../components/Pagination'
  import {param} from '../../api/commonMG'

  export default {
    data: () => {
      var validateMoney = (rule, value, callback) => {
        if (value === '' || value == undefined || value == null) {
          return callback(new Error('请输入满额使用金额'));
        } else if (!(/(^0\.[1-9]\d?$)|(^0\.\d[1-9]?$)|(^[1-9]\d{0,7}(\.\d{0,2})?$)/.test(value))) {
          return callback(new Error('输入长度过长或格式不正确'));
        }  else {
          return callback();
        }
      };
      return {
        loading: false, // 显示加载
        voucherDialogVisible: false, // 控制页面显示与隐藏
        sortDialogVisible: false,
        brandDialogVisible: false,
        couponDialogVisible: false,
        dialogTitle: '', // 标题
        param: '',   // 按钮
        param2: '',   // 按钮
        VoucherRuleType: [],  // 优惠券类型
        selectTableData: [],
        sortButtonText: '',
        brandButtonText: '',
        productOptions: [],
        ProductBrandList:[],
        defaultParams: {
          label: 'text',
          value: 'id',
          children: 'children'
        },
        productId: '',
        formInline: {
          page: 1,
          rows: 10,
          rule_name: '',
          full_money: '',
          voucher_rule_type: '',
          order_full_use: ''
        },
        couponFormInline: {
          page: 1,
          rows: 10,
          status:'',
          voucher_rule_id: "",
          voucher_code: '',
          voucher_type: ''
        },
        voucherForm: {
          id: '',
          rule_name: '',
          contain_delivery: '1',
          order_full_use: '1',
          voucher_rule_type: '',
          full_money: ''
        },
        sortForm: {
          id: "",
          voucher_rule_id: "",
          product_sort_id: ""
        },
        brandForm: {
          id: "",
          voucher_rule_id: "",
          product_brand_id:""
        },
        listData: [], //用户数据
        couponlistData:[],
        // 分页参数
        pageparm: {
          currentPage: 1,
          pageSize: 10,
          total: 10
        },
        couponpageparm: {
          currentPage: 1,
          pageSize: 10,
          total: 10
        },

        sale_id: '',
        // rules表单验证
        rules: {
          rule_name: [{required: true, message: '请输入规则名称', trigger: 'blur'}],
          contain_delivery: [{required: true, message: '请选择是否包含邮费', trigger: 'blur'}],
          order_full_use: [{required: true, message: '请选择是否单笔订单满额使用', trigger: 'blur'}],
          voucher_rule_type: [{required: true, message: '请选择规则类型', trigger: 'blur'}],
          full_money: [{required: true, validator: validateMoney, trigger: 'blur'}],
        },
        sortrules:{
          product_sort_id: [{required: true, message: '请选择分类名称', trigger: 'change'}],
        },
        brandrules:{
          product_brand_id: [{required: true, message: '请选择品牌名称', trigger: 'change'}],
        },
        containList: [{
          name: '是',
          value: 1
        }, {
          name: '否',
          value: 0
        }],
        orderList: [{
          name: '是',
          value: 1
        }, {
          name: '否',
          value: 0
        }],
      }
    },
    // 注册组件
    components: {
      Pagination
    },
    /**
     * 创建完毕
     */
    created() {
      this.getdata(this.formInline)
    },
    mounted() {
      this.getParam('VoucherRuleType')        // 优惠券类型
    },
    /**
     * 里面的方法只有被调用才会执行
     */
    methods: {
      // 过滤
      Formatter(value, type) {
        if (type == 'VoucherRuleType') {
          for (let item of this.VoucherRuleType) {
            if (item.code == value) {
              if(item.name=='全场通用') {
                return '店铺通用'
              } else {
                return item.name
              }
            }
          }
        }
      },
      //获取系统字典
      getParam(type) {
        param(type)
          .then(res => {
            if (res.success) {
              if (type == 'VoucherRuleType') {
                this.VoucherRuleType = res.content;
              }
            }
          })
          .catch(err => {
          })
      },
      handleClick(tab, event) {
        console.log(tab, event);
      },
      // 新增优惠券规则
      addsortdialog() {
        this.voucherDialogVisible = true;
        this.dialogTitle = '新增优惠券规则';
        this.voucherForm = {
          id: '',
          rule_name: '',
          contain_delivery: '1',
          order_full_use: '1',
          voucher_rule_type: '',
          full_money: ''
        };
        this.param = '保存';
        this.param2 = '重置';
      },
      // 修改优惠券规则
      editupdate() {
        if (this.selectTableData.length == 0) {
          this.$message.error('请选择一条数据再操作!');
          return
        }
        if (this.selectTableData.length > 1) {
          this.$message.error('当前操作只能选择一条数据!');
          return
        }
        this.productId = this.selectTableData[0].id;
        this.dialogTitle = '修改优惠券规则';
        this.param = '确定修改';
        this.param2 = '重置';
        this.voucherDialogVisible = true;

        this.voucherForm.rule_name = this.selectTableData[0].rule_name;
        this.voucherForm.contain_delivery = this.selectTableData[0].contain_delivery;
        this.voucherForm.order_full_use = this.selectTableData[0].order_full_use;
        this.voucherForm.voucher_rule_type = this.selectTableData[0].voucher_rule_type;
        this.voucherForm.full_money = this.selectTableData[0].full_money;
      },
      delProduct() {
        if (this.selectTableData.length == 0) {
          this.$message.error('请选择一条数据再操作!');
          return
        }
        if (this.selectTableData.length > 1) {
          this.$message.error('当前操作只能选择一条数据!');
          return
        }
        const title = '删除优惠券规则?';
        this.$confirm(title, '是否删除优惠券规则', {
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        }).then(() => {
          this.loading = true;
          CouponusagerulesDelete(this.selectTableData[0].id)
            .then(res => {
              this.loading = false
              if (res.success == false) {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              } else {
                this.$message({
                  type: 'success',
                  message: '删除成功!'
                });
                this.getdata(this.formInline)
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('网络错误，请稍后再试！')
            })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          });
        });
      },
      // 获取公司列表
      getdata(parameter) {
        this.loading = true
        CouponusagerulesList(parameter)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              this.listData = res.content.rows
              // 分页赋值
              this.pageparm.currentPage = this.formInline.page
              this.pageparm.pageSize = this.formInline.rows
              this.pageparm.total = res.content.total
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      getcoupondata(parameter) {
        couponList(parameter)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              this.couponlistData = res.content.rows
              // 分页赋值
              this.couponpageparm.currentPage = this.couponFormInline.page
              this.couponpageparm.pageSize = this.couponFormInline.rows
              this.couponpageparm.total = res.content.total
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      // 分页插件事件
      callFather(parm) {
        this.formInline.page = parm.currentPage
        this.formInline.rows = parm.pageSize
        this.getdata(this.formInline)
      },
      couponCallFather(parm) {
        this.couponFormInline.page = parm.currentPage
        this.couponFormInline.rows = parm.pageSize
        this.getcoupondata(this.couponFormInline)
      },
      // 新增优惠券规则
      saveSort(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.loading = true;
            if (this.dialogTitle == '新增优惠券规则') {
              CouponusagerulesAdd(this.voucherForm)
                .then(res => {
                  this.loading = false
                  if (res.success == false) {
                    this.$message({
                      type: 'info',
                      message: res.msg
                    })
                  } else {
                    this.$message({
                      type: 'success',
                      message: '您已成功新增优惠券规则'
                    });
                    this.voucherDialogVisible = false;
                    this.getdata(this.formInline)
                  }
                })
                .catch(err => {
                  this.loading = false
                  this.$message.error('网络错误,请稍后再试!')
                })
            } else {
              this.voucherForm.id = this.productId;
              this.loading = true;
              CouponusagerulesUpdate(this.voucherForm)
                .then(res => {
                  this.loading = false
                  if (res.success == false) {
                    this.$message({
                      type: 'info',
                      message: res.msg
                    })
                  } else {
                    this.$message({
                      type: 'success',
                      message: '您已成功修改优惠券规则'
                    });
                    this.voucherDialogVisible = false;
                    this.getdata(this.formInline)
                  }
                })
                .catch(err => {
                  this.loading = false;
                  this.$message.error('网络错误,请稍后再试!')
                })
            }
          } else {
            console.log('error submit!!');
          }
        });
      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
      },
      handleClose() {
        this.$refs["voucherForm"].resetFields();
        this.voucherDialogVisible = false;
      },
      // 搜索事件
      search() {
        this.formInline.page = 1;
        this.getdata(this.formInline)
      },
      // 搜索事件
      couponSearch() {
        this.couponFormInline.page = 1;
        this.getcoupondata(this.couponFormInline)
      },
      handleRemove(file) {
        console.log(file);
      },
      handleSelectionChange(val) {
        this.selectTableData = val
      },
      //查看品牌
      lookBrand(id) {
        this.loading = true;
        this.brandDialogVisible = true;
        this.brandForm.product_brand_id = '';
        this.brandForm.voucher_rule_id = id;
        productBrand('')
          .then(res => {
            if (res.success) {
              this.ProductBrandList = res.content;
            }
          })
          .catch(err => {

          })
        VoucherRulesbrandInfo(id)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              if (res.content) {
                this.brandButtonText = '修改';
                this.brandForm.id = res.content.id;
                this.brandForm.product_brand_id = res.content.product_brand_id;
                this.brandForm.voucher_rule_id = res.content.voucher_rule_id;
              } else {
                this.brandButtonText = '添加'
              }
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      handleBrandClose() {
        // this.$refs["brandForm"].resetFields();
        this.brandDialogVisible = false;
        this.brandButtonText = '';
      },
      clickBrand() {
        if (this.brandButtonText == '添加') {
          this.brandButtonText = '保存'
        } else {
          if (this.brandButtonText == '保存') {
            this.loading = true;
            VoucherRulesbrandAdd(this.brandForm)
              .then(res => {
                this.loading = false
                if (res.success == false) {
                  this.$message({
                    type: 'info',
                    message: res.msg
                  })
                } else {
                  this.$message({
                    type: 'success',
                    message: '您已成功为优惠券规则添加品牌'
                  });
                  this.brandDialogVisible = false;
                }
              })
              .catch(err => {
                this.loading = false
                this.$message.error('网络错误，请稍后再试！')
              })
          } else {
            this.loading = true
            VoucherRulesbrandUpdate(this.brandForm)
              .then(res => {
                this.loading = false
                if (res.success == false) {
                  this.$message({
                    type: 'info',
                    message: res.msg
                  })
                } else {
                  this.$message({
                    type: 'success',
                    message: '您已成功为优惠券规则修改品牌'
                  });
                  this.brandDialogVisible = false;
                }
              })
              .catch(err => {
                this.loading = false
                this.$message.error('网络错误，请稍后再试！')
              })
          }

        }
      },
      //查看分类
      lookSort(id) {
        this.sortDialogVisible = true;
        this.sortForm.product_sort_id = '';
        this.sortForm.voucher_rule_id = id;
        productTree()
          .then(res => {
            if (res.success) {
              this.productOptions = res.content;
            }
          })
          .catch(err => {
          })
        this.loading = true;
        VoucherRulesCategoryInfo(id)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              if (res.content) {
                this.sortButtonText = '修改'
                this.sortForm.id = res.content.id;
                this.sortForm.product_sort_id = [res.content.sort1_id,res.content.sort2_id,res.content.sort3_id]
                this.sortForm.voucher_rule_id = res.content.voucher_rule_id;
              } else {
                this.sortButtonText = '添加'
              }
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      handleSortClose() {
        // this.$refs["sortForm"].resetFields();
        this.sortDialogVisible = false;
        this.sortButtonText = '';
      },
      clickSort() {
        if (this.sortButtonText == '添加') {
          this.sortButtonText = '保存'
        } else {
          this.sortForm.product_sort_id = this.sortForm.product_sort_id.pop();
          if (this.sortButtonText == '保存') {
            VoucherRulesCategoryAdd(this.sortForm)
              .then(res => {
                this.loading = false
                if (res.success == false) {
                  this.$message({
                    type: 'info',
                    message: res.msg
                  })
                } else {
                  this.$message({
                    type: 'success',
                    message: '您已成功为优惠券规则添加分类'
                  });
                  this.sortDialogVisible = false;
                }
              })
              .catch(err => {
                this.loading = false
                this.$message.error('网络错误，请稍后再试！')
              })
          } else {
            VoucherRulesCategoryUpdate(this.sortForm)
              .then(res => {
                this.loading = false
                if (res.success == false) {
                  this.$message({
                    type: 'info',
                    message: res.msg
                  })
                } else {
                  this.$message({
                    type: 'success',
                    message: '您已成功为优惠券规则修改分类'
                  });
                  this.sortDialogVisible = false;
                }
              })
              .catch(err => {
                this.loading = false
                this.$message.error('网络错误，请稍后再试！')
              })
          }

        }
      },
      productSortChange(sort_id, brand_id, type) {

      },
      //查看优惠券
      lookCoupon(id) {
        this.couponDialogVisible = true;
        this.couponFormInline.voucher_rule_id = id;
        this.getcoupondata(this.couponFormInline)
      },
      prodHandleClose() {
        this.couponFormInline = {
          page: 1,
          rows: 10,
          status:'',
          voucher_rule_id: "",
          voucher_code: '',
          voucher_type: ''
        }
        this.couponDialogVisible = false
      },
      //双击复制
      cellDbClick(row, column, cell, event) {
        if (row.rule_name == cell.innerText || row.full_money == cell.innerText) {
          if (event.type === "dblclick") {
            var save = function (e) {
              e.clipboardData.setData('text/plain', cell.innerText);
              e.preventDefault();//阻止默认行为
            }
            document.addEventListener('copy', save);
            document.execCommand("copy");
            document.removeEventListener('copy', save);
          }
          this.$message({message: '复制成功', type: 'success'})
        }
      }
    }
  }
</script>

<style scoped>
  .contianer {
    background: #fff;
    padding: 20px;
  }

  /deep/ .user-search .el-input__inner {
    height: 40px;
    line-height: 40px;
  }

  /deep/ .user-search .el-form-item {
    margin-bottom: 10px;
  }

  /deep/ .user-search .el-button--small {
    height: 40px;
  }

  /deep/ .el-dialog--center {
    border-radius: 8px !important;
  }

  /deep/ .voucherForm .el-input__inner {
    height: 40px;
    line-height: 40px;
    width: 320px;
  }

  /deep/ .voucherForm .el-input {
    width: 320px;
  }

  /deep/ .voucherForm .el-input--small {
    width: 320px;
  }

  /deep/ .sortForm .el-input__inner {
    height: 40px;
    line-height: 40px;
    width: 320px;
  }

  /deep/ .sortForm .el-input {
    width: 320px;
  }

  /deep/ .sortForm .el-input--small {
    width: 320px;
  }

  /deep/ .brandForm .el-input__inner {
    height: 40px;
    line-height: 40px;
    width: 320px;
  }

  /deep/ .brandForm .el-input {
    width: 320px;
  }

  /deep/ .brandForm .el-input--small {
    width: 320px;
  }

  /deep/ .el-message-box__title {
    color: #409EFF !important;
  }

  /deep/ .el-dialog__title {
    color: #409EFF !important;
  }

  .add-button {
    background: #53B03C;
    border-color: #53B03C;
  }

  .edit-button {
    background: #58B7D6;
    border-color: #58B7D6;
  }

  .breadcrumb {
    margin-bottom: 15px;
  }
</style>





// WEBPACK FOOTER //
// src/views/Marketing/couponRules.vue